import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-users-employees-view",
  templateUrl: "./admin-users-employees-view.component.html",
  styleUrls: ["./admin-users-employees-view.component.css"],
})
export class AdminUsersEmployeesViewComponent implements OnInit {
  employeeView: boolean = true;
  s9Form: FormGroup;
  S9Data: any;
  file: any;
  truckImage: any;
  token: any;
  minDob = new Date();
  public invalidDob: boolean = false;
  today: any;

  constructor(
    private matdialogref: MatDialogRef<AdminUsersEmployeesViewComponent>,
    private matDialog: MatDialog,
    private formBuilder: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.S9Data = this.data;
    this.s9Form = this.formBuilder.group({
      username: ["", Validators.required],
      employee_id: [""],
      mobile: [""],
      email: [""],
      profile_pic: [""],
      joined_in: [""],
    });
    this.truckImage = this.S9Data.adminRegisterDetails.profile_pic;
    this.s9Form.patchValue({
      username: this.S9Data.username,
      mobile: this.S9Data.mobile,
      email: this.S9Data.email,
      employee_id: this.S9Data.adminRegisterDetails.employee_id,
    });
  }
  editUsers() {
    this.employeeView = false;
  }
  close() {
    this.matdialogref.close();
  }

  public onDateChnage(num: number) {
    if (num === 2 && this.s9Form.value.joined_in > this.today) {
      this.invalidDob = true;
    }
  }

  updateS9employee() {
    const employeeObj = {
      username: this.s9Form.value.username,
      mobile: this.s9Form.value.mobile,
      email: this.s9Form.value.email,
      profile_pic: this.truckImage,
      employee_id: this.s9Form.value.employee_id,
    };
    this.services
      .employeeUpdate(employeeObj, this.token, this.data._id)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.matdialogref.close();
            this.snackBar.open(
              "employee details updated successfully",
              "Success",
              {
                duration: 5000,
              }
            );
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status == 201) {
          this.truckImage = response.body.image_link;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
}
